import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'json-text',
  templateUrl: './json-text.component.html',
  styleUrls: ['./json-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonTextComponent),
      multi: true,
    },
  ],
})
export class JsonTextComponent implements ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public placeholder: string;
  @Input() public path: string;
  @Input() public name: string;
  @Input() public preserveEmpty: boolean;
  @Input() public height: number;

  onChange: (_: any) => void = (_: any) => {};

  value: any;
  json: any;

  constructor() {
    this.disabled = false;
  }
  writeValue(obj: any): void {
    this.value = _.get(obj, this.path);
    this.json = obj || {};
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  updateChanges() {
    if (this.value || this.preserveEmpty) {
      const change = _.set({}, this.path, this.value);
      this.json = _.merge(this.json, change);
    } else {
      _.unset(this.json, this.path);
    }

    this.onChange(this.json);
  }
}
